@if (page) {
  <main class="alternative-page">
    <nav class="breadcrumbs" aria-label="Breadcrumbs">
      <a routerLink="/">Home</a><span>/</span
      ><span>{{ page.brand }} alternative</span>
    </nav>
    <article>
      <header class="alternative-hero">
        <div>
          <span class="article-category">ALTERNATIVE GUIDE</span>
          <h1>{{ page.title }}</h1>
          <p>{{ page.description }}</p>
          <div class="alternative-meta">
            <span>{{ appName }} editorial team</span
            ><span>Independent guide</span>
          </div>
        </div>
        <div
          class="alternative-art {{ page.accent }}"
          aria-label="{{ page.brand }} alternative guide"
        >
          <span>{{ appName | uppercase }}</span
          ><strong>Meet people<br />on your terms.</strong
          ><i aria-hidden="true"></i>
        </div>
      </header>
      <div class="alternative-layout">
        <div class="alternative-content">
          <p class="article-lede">{{ page.intro }}</p>
          <h2>{{ page.angle }}</h2>
          <p>
            Different chat platforms suit different comfort levels. Some people
            want video immediately, others want an anonymous text conversation
            first. A useful alternative should explain what it offers clearly
            and let you choose how much you share.
          </p>
          <section class="alternative-highlight">
            <p class="eyebrow">WHAT {{ appName | uppercase }} OFFERS</p>
            <ul>
              @for (strength of page.strengths; track strength) {
                <li>{{ strength }}</li>
              }
            </ul>
          </section>
          <h2>Why choose a text-first alternative?</h2>
          <p>{{ page.strangeryapFit }}</p>
          <p>
            Interest matching is designed to improve the opening moment, not
            force a perfect match. You can select topics you enjoy, meet someone
            with a shared interest when available, or continue searching for a
            different conversation.
          </p>
          <h2>Choose the experience that fits you</h2>
          <p>
            If you are comparing random chat platforms, start with the format
            you feel comfortable using. Text is available on
            {{ appName }} today; future voice and video experiences will be
            introduced only when they meet the same privacy and safety standard.
          </p>
          <div class="alternative-links">
            <a routerLink="/anonymous-chat">Learn about anonymous chat </a
            ><a routerLink="/safety">Read safety guidance </a
            ><a routerLink="/blog">Explore the {{ appName }} Blog </a>
          </div>
          <section class="alternative-faq">
            <h2>Questions people ask</h2>
            @for (item of page.faq; track item.question) {
              <details>
                <summary>{{ item.question }}</summary>
                <p>{{ item.answer }}</p>
              </details>
            }
          </section>
        </div>
        <aside class="alternative-sidebar">
          <div>
            <p class="eyebrow">START HERE</p>
            <h2>Ready for a different kind of random chat?</h2>
            <p>Start a free anonymous text conversation with someone new.</p>
            <a class="primary-button" routerLink="/chat">Start chatting </a>
          </div>
          <div class="sidebar-links">
            <strong>Related pages</strong
            ><a routerLink="/talk-to-strangers-online"
              >Talk to strangers online</a
            ><a routerLink="/random-chat">Random chat</a
            ><a routerLink="/make-friends-online">Make friends online</a>
          </div>
        </aside>
      </div>
    </article>
  </main>
}
